import { render, staticRenderFns } from "./powerBox.vue?vue&type=template&id=4c21cca7&scoped=true&"
import script from "./powerBox.vue?vue&type=script&lang=js&"
export * from "./powerBox.vue?vue&type=script&lang=js&"
import style0 from "./powerBox.vue?vue&type=style&index=0&id=4c21cca7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21cca7",
  null
  
)

export default component.exports